// import 'babel-polyfill';
// import es6Promise from 'es6-promise';
import Vue from 'vue';
import VueLodash from 'vue-lodash';
import Fragment from 'vue-fragment';
import * as uiv from 'uiv';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { VueMaskDirective } from 'v-mask';
import store from './store';
import locale from './utils/datePickerLocale';
import './utils/veeValidations';
import './reset.css';
// import 'normalize.css';
import Accordion from './components/Accordion/Accordion.vue';
// Or as a directive
// es6Promise.polyfill();

Vue.directive('mask', VueMaskDirective);

Vue.config.productionTip = false;
Vue.prototype.window = window;
Vue.prototype.$store = store;

Vue.use(Fragment.Plugin);
Vue.use(VueLodash);
Vue.use(uiv, { locale });
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

new Vue({
  store,
  // @ts-ignore
  uiv,
  render: h => h(Accordion),
}).$mount('#app');
